import Vue from "vue";
import App from "./App.vue";
import router from "./router/router";
import store from "./store/index";
// import vbclass from "vue-body-class";
import { FETCH_CURRENT_PAGE, FETCH_SETTING} from "./store/actions.names";
import axios from "axios";

//add custom js
import VuePlyr from "vue-plyr";
import "vue-plyr/dist/vue-plyr.css";
import CoolLightBox from 'vue-cool-lightbox'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'
import VueNumber from 'vue-number-animation'
 
Vue.use(VueNumber)
Vue.use(CoolLightBox)
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import VueYoutube from "vue-youtube";
import "./vee-validate";
import * as VueGoogleMaps from "vue2-google-maps";
import AOS from "aos";
import "aos/dist/aos.css";
import * as ScrollMagic from "scrollmagic"; // Or use scrollmagic-with-ssr to avoid server rendering problems
import { TweenMax, TimelineMax } from "gsap"; // Also works with TweenLite and TimelineLite
import { ScrollMagicPluginGsap } from "scrollmagic-plugin-gsap";
ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);
import VueMeta from 'vue-meta'
Vue.use(VuePlyr);
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true,
  keyName: 'head'
})



Vue.use(require("vue-moment"));
Vue.use(VueAwesomeSwiper);
Vue.use(VueYoutube);

Vue.config.productionTip = false;
//store.dispatch(FETCH_SETTING_DATA);
store.dispatch(FETCH_SETTING).then(() => {
  // console.log("maploaded");
  Vue.use(VueGoogleMaps, {
    load: {
      key: store.getters.mapAPIKey
    },
    installComponents: true
  });
});
const isProd =
  process.env.NODE_ENV === "production" &&
  process.env.VUE_APP_DEVENV === "production";
  router.beforeEach((to: any, from: any, next: any) => {
    store.dispatch(FETCH_CURRENT_PAGE, to.path).then(() => {
      next();
    }).catch(err => {
      next();
    })
  });
Vue.config.productionTip = false;

new Vue({
  created() {
    AOS.init({ disable: "phone", once: true });
    AOS.refresh();
  },
  router,
  store,
  render: h => h(App)
}).$mount("#app");
